import React, { Component } from 'react';

class ExpandParagraph extends  Component {
  state = {
    isOpen: false,
  };
  expand = () => this.setState({isOpen: true});
  render() {

    return (
      <>
        {(this.props.children && (this.props.children.length < 275 || this.state.isOpen)) ?
          this.props.children.split('///').map((par, i) =><p className="text-center" key={i}>{par}</p>) :
          <p className="text-center">{this.props.children.slice(0, 280)}...
          <a
            onClick={this.expand}
          >Տեսնել ավելին</a></p>


        }
      </>
    )
  }

}
export default ExpandParagraph;